import { observer } from 'mobx-react';
import React from 'react';
import { FormattedMessage, IntlShape } from 'react-intl';
import { WebsiteFormBodyVM } from '../website-form-body.viewmodel';
import { WebsitePill } from '../website-pill/website-pill';
import DefaultButton from '../../../../../global/default-button/default-button';
import { DefaultPublicPages } from '../../../../../../api/custom-pages.dao';

export type Props = {
    vm: WebsiteFormBodyVM;
    intl: IntlShape;
    isPublicNavigation?: boolean;
};

export const PagesNavigation = observer(
    ({ vm, isPublicNavigation = false }: Props): JSX.Element => {
        const { defaultPagesVM, customPagesVM } = vm;
        const customPageList = customPagesVM.getCustomPages();
        return (
            <div className='default-pages-view'>
                {isPublicNavigation && <>
                    <WebsitePill
                        onClick={vm.showSignInPopup}
                        text={
                            <FormattedMessage
                                id='oe.footer.signInLanding'
                                defaultMessage='Sign In {prefix}'
                                description='Button text'
                                values={{
                                    prefix: '',
                                }}
                            />
                        }
                        isLandingPage={!vm.getRegistrationAsLandingPage()}
                        isActive={vm.isSignInPopupOpened()}
                    />
                    <WebsitePill
                        onClick={vm.showGeneralRegistrationFormPopup}
                        text={
                            <FormattedMessage
                                id='oe.passport.registrationLabel'
                                defaultMessage='Registration'
                                description='Label text'
                            />
                        }
                        isLandingPage={vm.getRegistrationAsLandingPage()}
                        isDisabled={!vm.registrationEnabled}
                        isActive={vm.isGeneralRegistrationOpened()}
                    />
                </>}
                {vm.pages.map(page =>
                    page.hasOwnProperty('customPageId') ? (
                        <WebsitePill
                            key={page.customPageId}
                            onClick={customPagesVM.editCustomPage.bind(customPagesVM, page.customPageId)}
                            text={`${page.label}`}
                            isDisabled={isPublicNavigation ? !page.publicEnabled : !page.enabled}
                            isLandingPage={isPublicNavigation ? false : page.landingPage}
                            isActive={defaultPagesVM.hasSubWindowOpened(page.customPageId)}
                        />
                    ) : (
                        (!isPublicNavigation || DefaultPublicPages.includes(page.type)) &&
                            <WebsitePill
                                key={page.type}
                                onClick={defaultPagesVM.openPageConfiguration.bind(defaultPagesVM, page.type)}
                                text={page.label}
                                isDisabled={isPublicNavigation ? !page.publicEnabled : !page.enabled}
                                isLandingPage={isPublicNavigation ? false : page.landingPage}
                                isActive={defaultPagesVM.hasSubWindowOpened(page.type)}
                            />
                    )
                )}
                <DefaultButton
                    text={
                        <FormattedMessage
                            id='oe.customPages.addCustomPage'
                            defaultMessage='{prefix}Add Custom Page'
                            values={{ prefix: '+ ' }}
                        />
                    }
                    disabled={customPageList.length > 50}
                    modifier={['slim', 'link']}
                    onClick={customPagesVM.createCustomPage}
                    className='pages-navigation_add-page'
                />
            </div>
        );
    }
);
